import { createDiscreteApi } from 'naive-ui'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    const { message } = createDiscreteApi(['message'])
    window.$message = message
  })
})
